module.exports = __webpack_public_path__ + "static/media/dungeon_wall.dfdf22ea.png";